import {Observable} from 'rxjs';
import {jobHunterAPI} from './provider/jobHunterAPI';
import {RestQueryParams} from './base/queryParams';

export function userAPI(accessToken: string, id: string): Observable<any> {
    return jobHunterAPI.get(`api/users/${id}`, new RestQueryParams(), {
        Authorization: `Bearer ${accessToken}`,
    });
}
